import { Images } from 'assets/images';
import { ImageLazy } from 'components/ImageLazy';
import { InputSection } from './fragments/InputSection';
import { Information } from './fragments/Information';
import {
  ContactUsWrapper,
  FullContactContainer,
  GetInTouch,
  AboutUsBlock,
  FormContainer,
  StyledImageContainer,
} from './styled';

export const Contact = () => (
  <ContactUsWrapper>
    <StyledImageContainer>
      <ImageLazy 
        height='100%' 
        width="100%" 
        hash="LvKdf6%Kn$WB1UR-jZj@IER-Wqof" 
        alt="contact-su-image" 
        src={Images.contactUsBackground} 
      />
    </StyledImageContainer>

    <FullContactContainer>
      <GetInTouch>Get In Touch</GetInTouch>

      <AboutUsBlock>
          Want to get in touch? Sometimes you need a little help from your friend,
          ITAH. Don't worry… we're here for you. Here's how you can
          reach us...
      </AboutUsBlock>

      <FormContainer>
        <InputSection/>

        <Information/>
      </FormContainer>
    </FullContactContainer>
  </ContactUsWrapper>
)
;
